import { Product, BlogPost } from './types';

export const SITE_ASSETS = {
  hero: {
    dog: "/hero_dog_main.jpg",
    cat: "/hero_cat_small.jpg",
    dog_fallback: "https://images.unsplash.com/photo-1548199973-03cce0bbc87b?auto=format&fit=crop&q=80&w=800",
    cat_fallback: "https://images.unsplash.com/photo-1514888286974-6c03e2ca1dba?auto=format&fit=crop&q=80&w=600"
  },
  about: {
    team: "/about_team_main.jpg",
    team_fallback: "https://images.unsplash.com/photo-1529429612779-c8e40df2f5ce?auto=format&fit=crop&q=80&w=1200"
  }
};

export const PRODUCTS: Product[] = [
  // Added is_active and renamed amazonUrls to amazon_url to match Product interface
  {
    id: 1,
    name: "Pork Entree 12oz",
    category: ["Dog Food"],
    price: 45.00,
    stock: 24,
    images: ["/p01_main.jpg", "/p01_hover.jpg", "/p01_gallery_1.jpg", "/p01_gallery_2.jpg"],
    badge: "Best Seller",
    description: "Single-source protein with wholesome grains for sustained energy.",
    tags: ['dog'],
    is_active: true,
    amazon_url: "https://www.amazon.com/dp/example1",
    nutrition: {
      calories: "450 kcal",
      protein_content: "28g",
      fat_content: "18g",
      fiber_content: "3g",
      serving_size: "1 cup"
    }
  },
  {
    id: 2,
    name: "Chicken Mini Patties",
    category: ["Cat Food"],
    price: 28.00,
    stock: 15,
    images: ["/p02_main.jpg", "/p02_hover.jpg", "/p02_gallery_1.jpg", "/p02_gallery_2.jpg"],
    badge: "Grain Free",
    description: "Rich in Omega-3s for a shiny coat and healthy skin.",
    tags: ['cat'],
    is_active: true,
    amazon_url: "https://www.amazon.com/dp/example2",
    nutrition: {
      calories: "120 kcal",
      protein_content: "15g",
      fat_content: "8g",
      serving_size: "3 patties"
    }
  },
  {
    id: 3,
    name: "Eco Duck Toy",
    category: ["Accessories"],
    price: 15.50,
    stock: 50,
    images: ["/p03_main.jpg", "/p03_hover.jpg", "/p03_gallery_1.jpg"],
    badge: "Eco-Friendly",
    description: "Durable, natural rubber toys safe for vigorous chewers.",
    tags: ['dog', 'cat', 'accessories'],
    is_active: true
  },
  {
    id: 4,
    name: "Vitality Chews",
    category: ["Supplements"],
    price: 22.00,
    stock: 32,
    images: ["/p04_main.jpg", "/p04_hover.jpg", "/p04_gallery_1.jpg", "/p04_gallery_2.jpg"],
    badge: "Scientific Formula",
    description: "Probiotics and pumpkin to support healthy digestion.",
    tags: ['dog', 'cat', 'supplements'],
    is_active: true,
    amazon_url: "https://www.amazon.com/dp/example4"
  },
  {
    id: 5,
    name: "Digestive Topper",
    category: ["Supplements"],
    price: 99.00,
    stock: 10,
    images: ["/p05_main.jpg", "/p05_hover.jpg", "/p05_gallery_1.jpg", "/p05_gallery_2.jpg", "/p05_gallery_3.jpg"],
    badge: "New Arrival",
    description: "A powerhouse of nutrients to add to any meal.",
    tags: ['dog', 'cat', 'supplements'],
    is_active: true,
    amazon_url: "https://www.amazon.com/dp/example5",
    consumable_for: [
      { id: 1, name: "Pork Entree 12oz" },
      { id: 2, name: "Chicken Mini Patties" }
    ]
  }
];

export const BLOG_POSTS: BlogPost[] = [
  {
    id: 1,
    title: "Why Transparency Matters in Pet Nutrition",
    excerpt: "We reject excessive marketing. Here's how to read a label like a pro.",
    content: `In a world where pet food aisles are flooded with buzzwords like "gourmet," "premium," and "human-grade," it can be incredibly difficult for pet owners to discern what is actually good for their furry friends. At Natuvía, we believe that transparency isn't just a marketing tactic—it's a moral obligation...`,
    date: "Nov 28, 2025",
    image: "/blog_01_main.jpg",
    fallbackImage: "https://images.unsplash.com/photo-1601758228041-f3b2795255f1?auto=format&fit=crop&q=80&w=800",
    category: "Education"
  },
  {
    id: 2,
    title: "The Science of 'Less is More'",
    excerpt: "Minimalist processing retains the nutritional vitality of raw ingredients.",
    content: `The modern pet food industry is often guilty of over-engineering. Complex formulas with dozens of synthetic additives are marketed as 'complete nutrition,' but often, these additives are necessary only because the base ingredients were poor quality to begin with...`,
    date: "Nov 15, 2025",
    image: "/blog_02_main.jpg",
    fallbackImage: "https://images.unsplash.com/photo-1535930749574-1399327ce78f?auto=format&fit=crop&q=80&w=800",
    category: "Nutrition"
  },
  {
    id: 3,
    title: "Winter Care for Senior Pets",
    excerpt: "Tips to keep your aging companions warm and comfortable this season.",
    content: `As the temperature drops, our senior pets feel the chill much more acutely than their younger counterparts...`,
    date: "Oct 30, 2025",
    image: "/blog_03_main.jpg",
    fallbackImage: "https://images.unsplash.com/photo-1548199973-03cce0bbc87b?auto=format&fit=crop&q=80&w=800",
    category: "Wellness"
  }
];